<template>
  <v-app class="survey-container">
    <!-- TOP BANNER -->
    <v-layout wrap class="no-grow">
      <v-flex xs12>
        <div class="top-gray">
          <div class="left">
            <img
              src="../assets/nsf-logo.png"
              width="319"
              alt="National Science Foundation. Where Discoveries Begin"
            />
          </div>
        </div>
      </v-flex>
    </v-layout>

    <!-- HEADER -->
    <v-layout wrap class="no-grow">
      <v-flex xs12>
        <div class="blue-bar">
          <h1>Welcome to the NSF Survey of Federal Funds for Research and Development</h1>
        </div>
      </v-flex>
    </v-layout>

    <!-- MAIN CONTENTS -->
    <v-layout wrap class="page-body bg-light-blue">
      <!-- LEFT: INTRODUCTION -->
      <v-flex xs1 />
      <v-flex xs5 class="flex-vert-ctr">
        <div class="contents-pane">
          <p>
            This survey is the primary source of detailed information about federal funding for R&D in the United States. NSF has conducted this annual census of federal agencies who fund R&D activities since 1951.
          </p>
          <p>
            The findings are used by policymakers in the executive and legislative branches of the federal government in determining policies, laws, and regulations affecting science, and by those in every sector of the economy who follow science trends. These findings are also used in the federal government’s calculation of U.S. Gross Domestic Product (GDP) at the national and state level, for policy analysis and for budget purposes for the Federal Laboratory Consortium for Technology Transfer, Small Business Innovation Research (SBIR), and Small Business Technology Transfer (STTR).
          </p>
          <p>This survey is authorized by the National Science Foundation Act of 1950, as amended, and the America COMPETES Reauthorization Act of 2010.</p>
        </div>
      </v-flex>

      <!-- RIGHT: SIGN-IN BOX-->
      <v-flex xs1 />
      <v-flex xs4 class="flex-vert-ctr">
        <div class="sign-in-box">
          <v-form>
            <v-layout wrap>
              <v-flex xs12>
                <h2>Sign in to access the online survey</h2>
                <div v-if="error" class="error-text">{{errorMessage}}</div>
              </v-flex>

              <v-flex class="logo-center" xs4>
                <img src="../assets/NSF_Logo_flat.png" alt="NSF logo" width="100px" />
              </v-flex>
              <v-flex xs8>

                <v-text-field
                  solo
                  class="log-in-fields"
                  placeholder="User ID"
                  v-model="username"
                  v-on:keyup.enter="login"
                />
                <v-text-field
                  solo
                  class="log-in-fields"
                  placeholder="Password"
                  v-model="password"
                  :type="'password'"
                  v-on:keyup.enter="login"
                />
                <v-layout wrap>
                  <v-flex>
                    <v-btn
                      normal
                      :loading="isLoading"
                      :disabled="!username || !password"
                      class="blue-button"
                      @click="login(1)"
                    >Login</v-btn>
                  </v-flex>
                  <v-flex class="margin-top">
                    <a href="#" @click="change">Forgot password?</a>
                  </v-flex>
                </v-layout>
             </v-flex>
            </v-layout>
          </v-form>
        </div>
      </v-flex>
      <v-flex xs1 />
    </v-layout>

    <!-- BOTTOM: ORANGE BAR -->
    <v-layout wrap class="bg-light-blue">
      <v-flex xs12>
				<div>
					<v-btn normal :loading="isLoading" style="color: white !important;background-color: #396ee0 !important; font-size: 12px; width: 300px;" @click="clearCache()">Please Clear The Browser Cache</v-btn>
				</div>
				<br/>
        <div >
          <h3>
            Please submit your survey response as soon as possible. Your timely and accurate responses are very important.
          </h3>
        </div>
      </v-flex>
    </v-layout>

    <!-- FOOTER -->
    <Footer></Footer>

  </v-app>
</template>

<script>
import { authService } from "@/services/authService.js";
import router from "@/router";
import { Footer } from "@/components/Footer.vue";
export default {
  name: "login",
  data() {
    return {
      username: "",
      password: "",
      displayPassword: false,
      isLoading: false,
      show: false,
      error: false,
      errorMessage:null,
      count: 0,
    };
  },
  methods: {
		clearCache(){
			location.reload();
		},
   login(incre) {
      this.$data.isLoading = true;
      let me = this;
      authService
        .login(this.$data.username, this.$data.password)
        .then(function(response) {
          me.$data.isLoading = false;
          // Redirect to home. Look at how to redirect to nextUrl?
          router.push({ name: "landing" });
        })
        .catch(function(response) {
          console.log("Test handle error in component",response);
          me.$data.error = true;
          me.count += incre;
          if(me.count>=5)
            me.errorMessage = "Account has been locked, you will be receiving an e-mail shortly to reset your password";
          else
            me.errorMessage = "User Id or Password may be incorrect, Attempted: " + me.count;
          me.$data.isLoading = false;
        });
    },
    change() {
      router.push({ name: "forgotpassword" });
    }
  }
};
</script>

<style scoped>
.center {
  text-align: center;
}
.login-container {
  border-radius: 5px;
  background-color: white;
  border: 1px solid #13314f;
}

.blue-title-text {
  font-family: Georgia, Times, Times New Roman, san-serif;
  color: #000000;
  font-size: 28px;
  font-weight: normal;
}
.blue-title-text a {
  color: #1b405a;
}
.bar-title {
  text-align: center;
}
.content-space {
  padding: 49px 23px;
  font-family: Arial, Helvetica, san-serif;
  font-size: 1em;
  line-height: 1.8125em;
  color: #5b5853;
}
.left {
  text-align: left;
  margin-left: 2%;
}
h1 {
  margin: 10px 0 !important;
  padding: 0 !important;
  border: none !important;
  font-family: Calibri, Georgia, Time New Roman, Times, Serif;
  color: white;
  font-size: 30px;
  line-height: 40px;
  font-weight: normal;
  margin: 0 0 11px 0;
}
h3 {
  font-family: Calibri, Georgia, Time New Roman, Times, Serif;
}

.seperator {
  /* color: #d9e2f3; */
  font-weight: normal;
  margin-left: 20px;
  margin-right: 20px;
  border-left: 1px solid rgb(255, 206, 115);
}
.contents-pane {
  /* margin-top: 5%;
  margin-bottom: 5%; */
  margin-left: -5%;
  background-color: #f2f7fa;
  padding: 3%;
  text-align: left;
  border-style: solid;
  border-width: 0px 0px 0px 15px;
  border-color: #0f5182;
  font-size: 11pt;
  color: black;
}
.logo-center {
  margin-top: 0%;
  margin-right: 0%;
  text-align: center;
}
.log-in-fields {
  margin-bottom: -15px;
  width: 275px;
}
.log-in-fields >>> input {
  text-align: left;
  background-color: white;
}
.indent {
  margin-left: 3%;
}
.margin-top {
  margin-top: 5px;
}
</style>
